/**************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/

export function trackPage(page) {
    try {
        window.digitalData = window.digitalData || {};
        window.digitalData.page = window.digitalData.page || {};
        window.digitalData.page = {
            ...window.digitalData.page,
            ...page
        };
        window._satellite && window._satellite.track('page');
    } catch (error) {
        console.error(error);
    }
}

export function trackEvent(event) {
    try {
        window.digitalData = window.digitalData || {};
        if (!Array.isArray(window.digitalData.event)) {
            window.digitalData.event = [];
        }
        window.digitalData.event.push(event);
        window._satellite && window._satellite.track('event');
    } catch (err) {
        console.error(err);
    }
}
